import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=6200f3a8"
import script from "./legend.vue?vue&type=script&lang=js"
export * from "./legend.vue?vue&type=script&lang=js"
import style0 from "./legend.vue?vue&type=style&index=0&id=6200f3a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports